import React from "react";
import PropTypes from "prop-types";
import LaboratorySuites from "./LaboratorySuites";
import Button from "../Button";
import Input from "../Input";
import MatrixInput from "../testing/MatrixInput";
import { fetchJson, post } from "../../lib/Fetching";

class LaboratorySuiteSearcher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      matrix_id: props.matrix_id || null,
      selectedLaboratorySuites: [],
      laboratorySuites: []
    };
  }

  setSelectedSuites = selectedLaboratorySuites => {
    this.setState({ selectedLaboratorySuites });
  };

  onSearchChange = event => {
    var search = event.target.value;
    this.setState({ search }, this.filterLaboratorySuites);
  };

  onMatrixChange = options => {
    var matrix_id = "";
    if (options.length > 0) {
      matrix_id = options.map(option => option.value).join(",");
    }
    this.setState({ matrix_id }, this.filterLaboratorySuites);
  };

  isReadyToSearch() {
    const { search } = this.state;
    return search.length >= 3;
  }

  filterLaboratorySuites = () => {
    const { search } = this.state;
    if (this.fetching) clearTimeout(this.fetching);
    if (!this.isReadyToSearch()) {
      this.setState({
        laboratorySuites: []
      });
    } else {
      this.fetching = setTimeout(this.findLaboratorySuites, 300);
    }
  };

  findLaboratorySuites = () => {
    const { search, matrix_id } = this.state;
    this.setState({ loading: true });
    var url = "/laboratory_suites.json";
    var parameters = { "form[search]": search };
    if (matrix_id) parameters["form[matrix_id]"] = matrix_id;
    fetchJson(url, parameters).then(laboratorySuites => {
      this.setState({ laboratorySuites, loading: false });
    });
  };

  clear = () => {
    this.setState({
      search: "",
      laboratorySuites: [],
      selectedLaboratorySuites: []
    });
  };

  submit = () => {
    const { parent_quote_group_id, onSuitesAdded, attempt_id } = this.props;
    const { selectedLaboratorySuites } = this.state;
    return post("/quoting/laboratory_suites.json", {
      attempt_id: attempt_id,
      parent_quote_group_id: parent_quote_group_id,
      laboratory_suite_id: selectedLaboratorySuites.map(ls => ls.id)
    })
      .then(json => {
        onSuitesAdded(json.ids);
        this.clear();
      })
      .catch(e => alert("Could not add suites: " + e.message));
  };

  // Do not include already selected suites
  availableLaboratorySuites = () => {
    const { laboratorySuites } = this.state;
    return laboratorySuites;
  };

  render() {
    const { onCancel, matrixLocked } = this.props;
    const { search, selectedLaboratorySuites, loading } = this.state;
    const laboratorySuites = this.availableLaboratorySuites();
    return (
      <div className="panel panel-default" style={{ marginBottom: 0 }}>
        <div className="panel-body">
          <div className="form-inline" style={{ textAlign: "center" }}>
            <div className="form-group">
              <Input
                onPressEscape={onCancel}
                autoFocus
                className="form-control"
                placeholder="Enter laboratory suite name..."
                type="text"
                id="contact_name"
                value={search}
                style={{ width: 300 }}
                onChange={this.onSearchChange}
              />
            </div>
            <div className="form-group" style={{ marginLeft: 20 }}>
              {!matrixLocked && <MatrixInput multiple onChange={this.onMatrixChange} />}
            </div>
            <div className="form-group" style={{ marginLeft: 20 }}>
              <Button title="Cancel" onClick={onCancel} />
            </div>
          </div>
          {laboratorySuites.length == 0 && this.isReadyToSearch() && <p>No suites found</p>}
          {(loading || laboratorySuites.length > 0) && (
            <div className="btn-toolbar" style={{ marginTop: 10 }}>
              {loading ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                <LaboratorySuites
                  laboratorySuites={laboratorySuites}
                  selected={false}
                  onSelected={this.setSelectedSuites}
                />
              )}
              {laboratorySuites.length > 0 && (
                <Button
                  disabled={selectedLaboratorySuites.length == 0}
                  title="Add Laboratory Suite"
                  primary
                  onClick={this.submit}
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const customStyles = {
  control: (base, state) => ({
    ...base,
    width: 400
  })
};

export default LaboratorySuiteSearcher;
